import type { AIMessageDraft } from 'bundles/enterprise-admin-messaging-v2/components/AIMessageModal/types';

/**
 * Placeholder audience for a generated draft. The generate API only returns
 * the message copy (see `useGenerateEmailContent`); the audience cohort comes
 * from a separate cohort API that hasn't shipped yet. Remove this once that
 * API lands and the real cohort is wired in.
 */
export const mockGenerateAudience = (): Pick<AIMessageDraft, 'audienceSummary' | 'audienceCount'> => ({
  audienceSummary: '150 inactive learners in the last 7 days',
  audienceCount: 150,
});
